import React, { ReactElement, ReactNode } from "react";
import { Link } from "gatsby";
import {
  getScenarioMenuHref,
  isV2ScenarioMenuLink,
} from "../../utils/scenario-v2-urls";

interface ScenarioMenuLinkProps {
  type: string;
  name: string;
  children: ReactNode;
}

export default ({
  type,
  name,
  children,
}: ScenarioMenuLinkProps): ReactElement => {
  const href = getScenarioMenuHref(type, name);

  if (isV2ScenarioMenuLink(type, name)) {
    return <a href={href}>{children}</a>;
  }

  return <Link to={href}>{children}</Link>;
};
